"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNumberGridFilterValue = exports.buildNumberFilterValueFromUIDataGridFilter = exports.getFiniteNumber = void 0;
const ui_components_1 = require("@groupby/ui-components");
const getFiniteNumber = (value) => {
    if (typeof value === 'number')
        return Number.isFinite(value) ? value : undefined;
    if (typeof value === 'string' && value.trim() !== '') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    return undefined;
};
exports.getFiniteNumber = getFiniteNumber;
const buildNumberFilterValueFromUIDataGridFilter = (operator, value) => {
    const [arrayLow, arrayHigh] = Array.isArray(value)
        ? value
        : [undefined, undefined];
    const scalarValue = (0, exports.getFiniteNumber)(value);
    const low = arrayLow !== null && arrayLow !== void 0 ? arrayLow : scalarValue;
    const high = arrayHigh !== null && arrayHigh !== void 0 ? arrayHigh : scalarValue;
    const exactValue = low !== null && low !== void 0 ? low : high;
    switch (operator) {
        case ui_components_1.NumberFilterOperatorTypes.Between:
            return arrayLow != null || arrayHigh != null ? { low: arrayLow, high: arrayHigh } : null;
        case ui_components_1.NumberFilterOperatorTypes.Equal:
        case ui_components_1.NumberFilterOperatorTypes.NotEqual:
            return exactValue != null ? { low: exactValue, high: exactValue, operator } : null;
        case ui_components_1.NumberFilterOperatorTypes.GreaterThanOrEqual:
            return low != null ? { low, operator } : null;
        case ui_components_1.NumberFilterOperatorTypes.LessThanOrEqual:
            return high != null ? { high, operator } : null;
        default:
            return null;
    }
};
exports.buildNumberFilterValueFromUIDataGridFilter = buildNumberFilterValueFromUIDataGridFilter;
const buildNumberGridFilterValue = (operator, filter) => {
    const low = (0, exports.getFiniteNumber)(filter.low);
    const high = (0, exports.getFiniteNumber)(filter.high);
    const exactValue = low !== null && low !== void 0 ? low : high;
    switch (operator) {
        case ui_components_1.NumberFilterOperatorTypes.Equal:
        case ui_components_1.NumberFilterOperatorTypes.NotEqual:
            return exactValue;
        case ui_components_1.NumberFilterOperatorTypes.GreaterThanOrEqual:
            return low;
        case ui_components_1.NumberFilterOperatorTypes.LessThanOrEqual:
            return high;
        default:
            return [low, high];
    }
};
exports.buildNumberGridFilterValue = buildNumberGridFilterValue;
